export function getChangedFieldsValues(dirtyFields, formValues) {
  let values = {};

  for (const key in dirtyFields) {
    let fieldValue;
    if (!dirtyFields[key]) {
      continue;
    }

    if (Array.isArray(dirtyFields[key]) || typeof dirtyFields[key] !== 'object') {
      fieldValue = formValues[key];
    } else {
      fieldValue = getChangedFieldsValues(dirtyFields[key], formValues[key]);
    }

    values = {...values, [key]: fieldValue};
  }

  return values;
}
